import styled from 'styled-components';

export const NotificationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => (props.isUnread ? '#FAFBFF' : '#FFFFFF')};
  cursor:pointer;
  padding: 20px; /* Added padding for better spacing */
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); /* Adds a subtle shadow */
  width: 100%; /* Makes sure it takes full width */
  border-bottom: ${(props) => (props.isWarning ? '2px solid red' : '1px solid #DCDEE4')};
`;

export const LeftSection = styled.div`
  display: flex;
  gap: 12px;
  flex: 1; /* Allows text section to take available space without affecting image */
`;
export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 80vw; /* Ensures text stays within a reasonable width */
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 50px; /* Increased size */
  height: 50px;
`;

export const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

export const IconOverlay = styled.div`
  position: absolute;
  bottom: -5px;
  right: -4px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden; /* Prevents extra background */
`;

export const IconImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures the image fills the space */
  border-radius: 50%;
`;

export const RightSection = styled.div`
  display: flex;
  gap: 8px;
  margin-right: 20px;
`;

export const WheelImage = styled.img`
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius:10px
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
  margin: 8px 0;
`;

export const StyledButton = styled.button`
  background-color: ${(props) => (props.variant === 'accept' ? '#084394' : 'transparent')};
  color: ${(props) => (props.variant === 'accept' ? 'white' : 'grey')};
  border: ${(props) => (props.variant === 'accept' ? 'none' : '1px solid #e1e1e1')};
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    background-color: ${(props) => (props.variant === 'accept' ? '#053b85' : '#f9f9f9')};
  }
`;

export const GreenDot = styled.div`
  width: 12px;
  height: 12px;
  background-color: #77cccd;
  border-radius: 50%;
  align-self: center;
`;
